import { IDestinationList } from "../../models/IDestinationList";
import { DESTINATION_SET_DESTINATION } from "./destination-types";

export const setDestinations =
  (destinations: IDestinationList[]) => (dispatch: any) => {
    dispatch({ type: DESTINATION_SET_DESTINATION, payload: destinations });
  };
